module.exports = __webpack_public_path__ + "static/media/devto.20747487.svg";